import { guideConstants } from "../../constants"
import { guideService } from "../../../services/api.guides"
import { notify } from 'reapop'

export const countryActions = {
  getAll,
  getById,
  create,
  update,
  archive,
  delete: _delete
};


function getAll(params) {
  return (dispatch) => {
    dispatch(request());

    guideService.getAllCountries(params).then(
      (response) => dispatch(success(response)),
      (error) => {
        dispatch(failure(error.message));
        dispatch(notify({ title: "Ошибка при получении списка стран", message: error.message, status: 'error', image: "/public/assets/images/illustrations/close.svg" }))
      }
    );
  };

  function request() {
    return { type: guideConstants.GETALL_REQUEST_COUNTRIES };
  }
  function success(response) {
    return { type: guideConstants.GETALL_SUCCESS_COUNTRIES, response };
  }
  function failure(error) {
    return { type: guideConstants.GETALL_FAILURE_COUNTRIES, error };
  }
}

function getById(id) {
  return (dispatch) => {
    dispatch(request(id));

    guideService.getCountryById(id).then(
      (response) => {
        dispatch(success(response));
      },
      (error) => {
        dispatch(failure(error.message));
        dispatch(notify({ title: "Ошибка", message: error.message, status: 'error', image: "/public/assets/images/illustrations/close.svg" }))
      }
    );
  };

  function request(id) {
    return { type: guideConstants.GETBYID_REQUEST_COUNTRIES, id };
  }
  function success(response) {
    return { type: guideConstants.GETBYID_SUCCESS_COUNTRIES, response };
  }
  function failure(error) {
    return { type: guideConstants.GETBYID_FAILURE_COUNTRIES, error };
  }
}

function create(params) {
  return async (dispatch) => {
    dispatch(request(params));

    try {
      const response = await guideService.createCountry(params);
      dispatch(success(response.result));
      dispatch(notify({ title: "Успешно", message: response.message, status: 'success', image: "/public/assets/images/illustrations/check.svg" }));
      return response;
    } catch (error) {
      dispatch(failure(error.message));
      dispatch(notify({ title: "Ошибка", message: error.message, status: 'error', image: "/public/assets/images/illustrations/close.svg" }));
      throw error;
    }
  };

  function request(response) {
    return { type: guideConstants.CREATE_REQUEST_COUNTRIES, response };
  }
  function success(response) {
    return { type: guideConstants.CREATE_SUCCESS_COUNTRIES, response };
  }
  function failure(error) {
    return { type: guideConstants.CREATE_FAILURE_COUNTRIES, error };
  }
}

function update(id, params) {
  return async (dispatch) => {
    dispatch(request(id));

    try {
      const response = await guideService.updateCountry(id, params);
      dispatch(success(response.result));
      dispatch(notify({
        title: "Успешно",
        message: response.message,
        status: 'success',
        image: "/public/assets/images/illustrations/check.svg"
      }));
      return response;
    } catch (error) {
      dispatch(failure(error.message));
      dispatch(notify({
        title: "Ошибка",
        message: error.message,
        status: 'error',
        image: "/public/assets/images/illustrations/close.svg"
      }));
      throw error;
    }
  };

  function request(id) {
    return { type: guideConstants.UPDATE_REQUEST_COUNTRIES, id };
  }
  function success(response) {
    return { type: guideConstants.UPDATE_SUCCESS_COUNTRIES, response };
  }
  function failure(error) {
    return { type: guideConstants.UPDATE_FAILURE_COUNTRIES, error };
  }
}

function archive(id) {
  return (dispatch) => {
    dispatch(request(id));

    guideService.archiveCountry(id).then(
      (response) => {
        dispatch(success(id));
        dispatch(notify({ title: "Успешно", message: response.message, status: 'success', image: "/public/assets/images/illustrations/check.svg" }));
      },
      (error) => {
        dispatch(failure(error.message));
        dispatch(notify({ title: "Ошибка", message: error.message, status: 'error', image: "/public/assets/images/illustrations/close.svg" }))
      }
    );
  };

  function request(id) {
    return { type: guideConstants.ARCHIVE_REQUEST_COUNTRIES, id };
  }
  function success(id) {
    return { type: guideConstants.ARCHIVE_SUCCESS_COUNTRIES, id };
  }
  function failure(error) {
    return { type: guideConstants.ARCHIVE_FAILURE_COUNTRIES, error };
  }
}

// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(id) {
  return (dispatch) => {
    dispatch(request(id));

    guideService.deleteCountry(id).then(
      (response) => {
        dispatch(success(id));
        dispatch(notify({ title: "Успешно", message: response.message, status: 'success', image: "/public/assets/images/illustrations/check.svg" }));
      },
      (error) => {
        dispatch(failure(id, error.message));
        dispatch(notify({ title: "Ошибка", message: error.message, status: 'error', image: "/public/assets/images/illustrations/close.svg" }))
      }
    );
  };

  function request(id) {
    return { type: guideConstants.DELETE_REQUEST_COUNTRIES, id };
  }
  function success(id) {
    return { type: guideConstants.DELETE_SUCCESS_COUNTRIES, id };
  }
  function failure(id, error) {
    return { type: guideConstants.DELETE_FAILURE_COUNTRIES, id, error };
  }
}
